import { render, staticRenderFns } from "./RecommendationsTable.vue?vue&type=template&id=26740a28"
import script from "./RecommendationsTable.vue?vue&type=script&lang=js"
export * from "./RecommendationsTable.vue?vue&type=script&lang=js"
import style0 from "./RecommendationsTable.vue?vue&type=style&index=0&id=26740a28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports